"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmojiTriggerButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const lucide_react_1 = require("lucide-react");
const emojiStorage_1 = require("./emojiStorage");
const emojiList_1 = require("./emojiList");
const EmojiPicker = ({ onSelect, visible }) => {
    const [activeCategory, setActiveCategory] = (0, react_1.useState)('recent');
    const recent = (0, emojiStorage_1.getRecentEmojis)();
    const common = (0, emojiStorage_1.getCommonEmojis)();
    const hasRecent = recent.length > 0;
    const handleEmojiClick = (emoji) => {
        (0, emojiStorage_1.recordEmojiUsed)(emoji);
        onSelect(emoji);
    };
    if (!visible)
        return null;
    const categories = [
        ...(hasRecent ? [{ id: 'recent', label: 'Recent', emojis: recent }] : []),
        { id: 'common', label: 'Most used', emojis: common },
        ...Object.entries(emojiList_1.EMOJI_CATEGORIES).map(([key, emojis]) => ({
            id: key.toLowerCase(),
            label: key,
            emojis,
        })),
    ];
    const activeData = categories.find((c) => c.id === activeCategory) || categories[0];
    return ((0, jsx_runtime_1.jsxs)("div", { style: {
            position: 'absolute',
            bottom: '100%',
            left: 0,
            right: 0,
            height: 300,
            background: '#18181b',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
        }, children: [(0, jsx_runtime_1.jsx)("div", { style: {
                    display: 'flex',
                    gap: 18,
                    padding: '10px 16px 0',
                    borderBottom: '1px solid #27272a',
                    overflowX: 'auto',
                }, children: categories.map((cat) => ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: () => setActiveCategory(cat.id), style: {
                        padding: '0 0 10px',
                        border: 'none',
                        borderBottom: activeCategory === cat.id ? '2px solid #ff6b35' : '2px solid transparent',
                        background: 'transparent',
                        color: activeCategory === cat.id ? '#ff6b35' : '#71717a',
                        fontWeight: activeCategory === cat.id ? 600 : 400,
                        fontSize: 13,
                        whiteSpace: 'nowrap',
                        cursor: 'pointer',
                    }, children: cat.label }, cat.id))) }), (0, jsx_runtime_1.jsx)("div", { style: {
                    flex: 1,
                    overflowY: 'auto',
                    padding: 14,
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gap: 6,
                    alignContent: 'start',
                }, children: activeData.emojis.map((emoji, i) => ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: () => handleEmojiClick(emoji), style: {
                        width: 40,
                        height: 40,
                        fontSize: 22,
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        borderRadius: 10,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }, onMouseEnter: (e) => {
                        e.currentTarget.style.background = '#27272a';
                    }, onMouseLeave: (e) => {
                        e.currentTarget.style.background = 'transparent';
                    }, children: emoji }, `${emoji}-${i}`))) })] }));
};
exports.default = EmojiPicker;
const EmojiTriggerButton = ({ onClick, active }) => ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: onClick, style: {
        padding: 10,
        border: 'none',
        background: 'transparent',
        color: active ? '#ff6b35' : '#71717a',
        cursor: 'pointer',
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }, children: (0, jsx_runtime_1.jsx)(lucide_react_1.Smile, { size: 22 }) }));
exports.EmojiTriggerButton = EmojiTriggerButton;
